/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DataRetentionPolicyEnum } from "./DataRetentionPolicyEnum";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
export const DataRetentionPolicyConfig = core.serialization.object({
    type: DataRetentionPolicyEnum,
    period: core.serialization.number(),
    environmentId: EnvironmentId,
});
